// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"724":"39c4da75","726":"6aee8c27","972":"39c4da75"}[chunkId] + ".chunk.css";
};